export default "__VITE_ASSET__DS1Tz2rB__"